const state = {
  list: [],
  isLoading: false,
  isUploading: false,
  filter: {},
  hasEmpty: false,
};

export default state;
